import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  code: stringField({ required: true })
};
